module.exports = __webpack_public_path__ + "static/media/DataRoom.7a7de4f7.png";